import React, { useState, useEffect } from "react";
import Footer from "./Footer";

const UnderAttack = () => {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    company: "",
    email: "",
    phone: "",
    location: "",
    attack: "",
  });

  const generateCaptcha = () => {
    const chars =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let result = "";
    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptcha(result);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (captchaInput !== captcha) {
      alert("Captcha does not match. Please try again.");
      generateCaptcha();
      setCaptchaInput("");
      return;
    }

    setSubmitting(true);
    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbzmr7AX0xJZ0PdPYYXArJZN8O0bHWGW9G2ZtuK2N_uGNXTSUaZrBwTSfhyzfqzVKHnL/exec",
        {
          method: "POST",
          mode: "no-cors",
          headers: { "Content-Type": "text/plain" },
          body: JSON.stringify({ ...formData }),
        },
      );
      setSubmitted(true);
    } catch (error) {
      console.error("Submission Error:", error);
      alert("Server error. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="font-sans min-h-screen flex flex-col">
      {/* TOP SECTION: Solid Green Background (Image Removed) */}
      <section className="bg-[#032d28] py-44 px-4 text-center">
        <div className="max-w-4xl mx-auto text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Experiencing an <span className="text-green-400">Attack?</span>
            <br />
            <span className="text-white">Act Now!</span>
          </h1>
          <p className="text-green-100 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed opacity-90">
            Every second counts. Our experts are ready to help you contain,
            analyze, and mitigate security breaches to minimize damage.
          </p>
        </div>
      </section>

      {/* BOTTOM SECTION: Increased size, White Background, Green Text */}
      <section className="bg-white text-green-800 py-32 px-4 flex-grow">
        <div className="max-w-7xl mx-auto">
          {!submitted ? (
            <div className="flex flex-col lg:flex-row gap-16 items-start">
              {/* Left Side: Info (Green Text) */}
              <div className="w-full lg:w-5/12">
                <h2 className="text-4xl font-extrabold mb-6 text-green-900">
                  Report an Incident
                </h2>
                <p className="text-gray-600 mb-10 text-lg leading-relaxed">
                  If a security breach strikes, swift action is your best
                  defense. Please provide details below so our response team can
                  mobilize.
                </p>

                <ul className="space-y-10">
                  {[
                    {
                      num: "01",
                      title: "Containment:",
                      text: "Disconnect affected systems immediately.",
                    },
                    {
                      num: "02",
                      title: "Investigation:",
                      text: "Trace the attack source with our experts.",
                    },
                    {
                      num: "03",
                      title: "Recovery:",
                      text: "Patch vulnerabilities and restore services.",
                    },
                  ].map((item, index) => (
                    <li key={index} className="flex gap-5 items-start">
                      <div className="flex-shrink-0 w-12 h-12 bg-green-700 rounded-xl flex items-center justify-center font-bold text-white text-lg shadow-md">
                        {item.num}
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-green-900">
                          {item.title}
                        </h3>
                        <p className="text-gray-600">{item.text}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Right Side: Form */}
              <div className="w-full lg:w-7/12 bg-gray-50 rounded-2xl p-10 shadow-2xl border border-green-50/50">
                <form
                  onSubmit={handleSubmit}
                  className="grid grid-cols-1 md:grid-cols-2 gap-6"
                >
                  <input
                    type="text"
                    name="firstName"
                    placeholder="First Name*"
                    required
                    value={formData.firstName}
                    onChange={handleChange}
                    className="border-2 border-green-100 p-4 rounded-lg focus:border-green-500 outline-none transition-all"
                  />
                  <input
                    type="text"
                    name="lastName"
                    placeholder="Last Name*"
                    required
                    value={formData.lastName}
                    onChange={handleChange}
                    className="border-2 border-green-100 p-4 rounded-lg focus:border-green-500 outline-none transition-all"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address*"
                    required
                    className="md:col-span-2 border-2 border-green-100 p-4 rounded-lg focus:border-green-500 outline-none transition-all"
                    value={formData.email}
                    onChange={handleChange}
                  />

                  <div className="flex gap-2">
                    <select className="border-2 border-green-100 p-4 rounded-lg bg-white">
                      <option>IN +91</option>
                    </select>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Phone*"
                      required
                      className="flex-1 border-2 border-green-100 p-4 rounded-lg focus:border-green-500 outline-none"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>

                  <input
                    type="text"
                    name="location"
                    placeholder="Location*"
                    required
                    className="border-2 border-green-100 p-4 rounded-lg focus:border-green-500 outline-none"
                    value={formData.location}
                    onChange={handleChange}
                  />

                  <textarea
                    name="attack"
                    placeholder="Describe the Attack*"
                    required
                    value={formData.attack}
                    onChange={handleChange}
                    className="md:col-span-2 border-2 border-green-100 p-4 rounded-lg h-32 focus:border-green-500 outline-none"
                  ></textarea>

                  <div className="md:col-span-2 flex flex-col md:flex-row gap-4 items-center bg-white p-4 rounded-lg border-2 border-green-50">
                    <input
                      type="text"
                      placeholder="Enter Captcha*"
                      required
                      value={captchaInput}
                      onChange={(e) => setCaptchaInput(e.target.value)}
                      className="w-full md:w-1/2 border-2 border-green-100 p-3 rounded focus:border-green-500 outline-none"
                    />
                    <div className="flex items-center gap-4 bg-green-50 px-6 py-2 rounded-lg font-mono text-2xl tracking-widest text-green-900 border border-green-200">
                      <span className="select-none">{captcha}</span>
                      <button
                        type="button"
                        onClick={generateCaptcha}
                        className="text-green-600 hover:rotate-180 transition-all duration-500"
                      >
                        ↻
                      </button>
                    </div>
                  </div>

                  <div className="md:col-span-2 pt-4">
                    <button
                      type="submit"
                      disabled={submitting}
                      className="w-full bg-green-700 hover:bg-green-800 text-white font-bold py-4 rounded-xl shadow-lg transition-transform active:scale-95 disabled:opacity-50"
                    >
                      {submitting ? "SENDING..." : "SUBMIT REPORT"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="inline-block p-6 rounded-full bg-green-100 text-green-700 text-5xl mb-6">
                ✓
              </div>
              <h2 className="text-5xl font-bold text-green-800 mb-4">
                Report Received
              </h2>
              <p className="text-xl text-gray-600">
                Our emergency team is reviewing your case and will call you
                shortly.
              </p>
              <button
                onClick={() => setSubmitted(false)}
                className="mt-10 text-green-600 font-bold hover:underline"
              >
                Submit another report
              </button>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default UnderAttack;
